/** 直觉草图费用本地记一笔（暂无专用 billing API） */

const STORAGE_KEY = 'psycheflow.iskCostLog';
const MAX_ENTRIES = 100;

export type IskCostLogEntry = {
  ipttqId: string;
  cost: number;
  model?: string | null;
  provider?: string | null;
  generatedAt?: string | null;
  recordedAt: string;
};

function readEntries(): IskCostLogEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** 上游费用按美元计价；展示换算为人民币（固定汇率 1 USD = 6.8 CNY），精确到小数点后 3 位 */
const ISK_USD_TO_CNY = 6.8;

export function formatIskCostDisplay(cost: number | null | undefined): string {
  const n = Number(cost);
  if (!Number.isFinite(n)) return '';
  return (n * ISK_USD_TO_CNY).toFixed(3);
}

export function recordIskCostLog(entry: Omit<IskCostLogEntry, 'recordedAt'> & { recordedAt?: string }): IskCostLogEntry {
  const next: IskCostLogEntry = {
    ipttqId: String(entry.ipttqId || '').trim(),
    cost: Number(entry.cost),
    model: entry.model ?? null,
    provider: entry.provider ?? null,
    generatedAt: entry.generatedAt ?? null,
    recordedAt: entry.recordedAt || new Date().toISOString(),
  };
  const list = [next, ...readEntries()].slice(0, MAX_ENTRIES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // ignore quota / private mode
  }
  return next;
}
